export default __webpack_public_path__ + "static/media/store_3d.9e114111.png";